import { Fragment, useEffect, useState } from "react";
import {
  Button,
  Grid,
  Box,
  Typography,
  Divider,
  Skeleton,
  Card,
  Chip,
  IconButton,
  useTheme,
  alpha,
  Paper,
} from "@mui/material";

import BasicModal from "../Modal/Modal";

import useStyles from "./styles";
import { useAuth } from "../../hooks/AuthContext";
import { useQuery } from "react-query";
import { DADOSBANCARIOS } from "../../util/typesReactQuery";
import useAlert from "../../hooks/useAlert";
import {
  getDadosBancariosCliente,
  desativaAtivaDadosBancarios,
} from "../../api/DadosBancarios";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Cadastrar from "./Cadastrar";
import { ButtonCustom } from "../Botoes/Button";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import AddIcon from "@mui/icons-material/Add";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";

export default function DadosBancarios({
  isLoading = false,
  formaPagamento,
  onNext,
  isOperacao = false,
}) {
  const classes = useStyles();
  const [dadosBancarios, setDadosBancarios] = useState([]);
  const { user } = useAuth();
  const { showAlertError, showAlertSuccess } = useAlert();
  const [showModalNew, setShowModalNew] = useState(false);
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [loadingAction, setLoadingAction] = useState(false);
  const theme = useTheme();

  useEffect(() => {
    if (!!error) {
      showAlertError(error);
      setError("");
    }
  }, [error]);

  useEffect(() => {
    if (!!successMessage) {
      showAlertSuccess(successMessage);
      setSuccessMessage("");
    }
  }, [successMessage]);

  const { refetch: refetchDadosBancarios, isLoading: isLoadingQuery } =
    useQuery(DADOSBANCARIOS, () => getDadosBancariosCliente(user.id, false), {
      onSuccess: (data) => {
        if (!data || !!data.errorMessage)
          showAlertError(
            `Ops, algo deu errado, por favor informe o suporte o seguinte error: Não foi possivel verificar se a loja esta aberta - R1B94 `
          );

        setDadosBancarios(data.data);
      },
      onError: (error) => {
        showAlertError(
          `Ops, algo deu errado, por favor informe o suporte o seguinte error: ${error} - RD88E `
        );
      },
    });

  const handlerNext = (event, dadosBancarios) => {
    let pagamento = {
      dadoBancario: {
        id: dadosBancarios.id,
        idBancoNacional: dadosBancarios.idBancoNacional,
        agencia: dadosBancarios.numeroAgencia,
        digitoAgencia: dadosBancarios.digitoAgencia,
        numeroConta: dadosBancarios.numeroConta,
        digitoConta: dadosBancarios.digitoConta,
        idTipoContaBancaria: dadosBancarios.idTipoContaBancaria,
        chavePix: dadosBancarios.chavePIX,
      },
    };

    onNext(event, pagamento);
  };

  const desativaAtiva = async (idDadosBancarios) => {
    setLoadingAction(true);
    const response = await desativaAtivaDadosBancarios(
      user.id,
      idDadosBancarios
    );

    if (!!response.errorMessage)
      throw new Error(
        `Ops, algo deu errado, por favor informe o seguinte erro ao suporte tecnico: ${response.errorMessage} - R6C28`
      );

    if (!!!response)
      throw new Error(
        `Ops, algo deu errado, por favor informe o seguinte erro ao suporte tecnico: Não foi possível ativar/desativar este Banco - R2937`
      );

    showAlertSuccess("Alteração feita com sucesso!");
    refetchDadosBancarios();
    setLoadingAction(false);
  };

  const DadosBancariosOperacao = ({ dados }) => {
    return (
      <Card
        elevation={2}
        sx={{
          mb: 2,
          borderRadius: 2,
          border: `1px solid ${theme.palette.divider}`,
          transition: "all 0.2s ease",
          "&:hover": {
            boxShadow: 4,
            transform: "translateY(-1px)",
            borderColor: theme.palette.primary.main,
          },
        }}
      >
        <Box
          sx={{
            p: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            cursor: "pointer",
          }}
          onClick={(event) => handlerNext(event, dados)}
        >
          <Box sx={{ display: "flex", alignItems: "center", flex: 1 }}>
            <AccountBalanceIcon
              sx={{
                color: theme.palette.primary.main,
                fontSize: 32,
                mr: 2,
              }}
            />

            <Box sx={{ flex: 1 }}>
              <Typography variant="h6" sx={{ fontWeight: 600, mb: 0.5 }}>
                {dados.bancoNacional.descricao}
              </Typography>

              {dados.chavePIX?.length > 1 ? (
                <Box>
                  <Chip
                    label="PIX"
                    size="small"
                    color="primary"
                    variant="filled"
                    sx={{ mb: 1 }}
                  />
                  <Typography variant="body2" sx={{ wordBreak: "break-all" }}>
                    <Box component="span" sx={{ fontWeight: 600 }}>
                      Chave:{" "}
                    </Box>
                    {dados.chavePIX}
                  </Typography>
                </Box>
              ) : (
                <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                  <Box>
                    <Typography
                      variant="caption"
                      sx={{ fontWeight: 600, display: "block" }}
                    >
                      Agência
                    </Typography>
                    <Typography variant="body2">
                      {dados.numeroAgencia}
                      {dados?.digitoAgencia ? `-${dados.digitoAgencia}` : ""}
                    </Typography>
                  </Box>

                  <Box>
                    <Typography
                      variant="caption"
                      sx={{ fontWeight: 600, display: "block" }}
                    >
                      Conta
                    </Typography>
                    <Typography variant="body2">
                      {dados.numeroConta}
                      {dados?.digitoConta ? `-${dados.digitoConta}` : ""}
                    </Typography>
                  </Box>
                </Box>
              )}
            </Box>
          </Box>

          <ArrowForwardIosIcon
            sx={{
              color: theme.palette.text.secondary,
              fontSize: 16,
            }}
          />
        </Box>
      </Card>
    );
  };

  const DadosBancariosGestao = ({ dados }) => {
    return (
      <Card
        elevation={1}
        sx={{
          mb: 2,
          p: 2,
          borderRadius: 2,
          border: `1px solid ${theme.palette.divider}`,
          "&:hover": {
            boxShadow: 3,
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            mb: 2,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <AccountBalanceIcon color="primary" />
            <Box>
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                {dados.bancoNacional.descricao}
              </Typography>
              <Chip
                label={dados.ativo ? "Ativo" : "Inativo"}
                size="small"
                color={dados.ativo ? "success" : "default"}
                variant="outlined"
              />
            </Box>
          </Box>

          <IconButton
            size="small"
            onClick={() => desativaAtiva(dados.id)}
            sx={{
              color: dados.ativo
                ? theme.palette.success.main
                : theme.palette.text.secondary,
            }}
          >
            {dados.ativo ? (
              <ToggleOnIcon fontSize="small" />
            ) : (
              <ToggleOffIcon fontSize="small" />
            )}
          </IconButton>
        </Box>

        <Divider sx={{ mb: 2 }} />

        {dados.chavePIX?.length > 1 ? (
          <Box>
            <Chip
              label="PIX"
              size="small"
              color="primary"
              variant="filled"
              sx={{ mb: 1 }}
            />
            <Typography variant="body2" sx={{ wordBreak: "break-all" }}>
              <Box component="span" sx={{ fontWeight: 600 }}>
                Chave:{" "}
              </Box>
              {dados.chavePIX}
            </Typography>
          </Box>
        ) : (
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <Typography variant="body2" sx={{ mb: 1 }}>
                <Box component="span" sx={{ fontWeight: 600 }}>
                  Agência:{" "}
                </Box>
                {dados.numeroAgencia}
                {dados?.digitoAgencia ? `-${dados.digitoAgencia}` : ""}
              </Typography>
              <Typography variant="body2">
                <Box component="span" sx={{ fontWeight: 600 }}>
                  Conta:{" "}
                </Box>
                {dados.numeroConta}
                {dados?.digitoConta ? `-${dados.digitoConta}` : ""}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="body2">
                <Box component="span" sx={{ fontWeight: 600 }}>
                  Tipo:{" "}
                </Box>
                {dados.tipoContaBancaria?.descricao || "Não informado"}
              </Typography>
            </Grid>
          </Grid>
        )}
      </Card>
    );
  };

  return (
    <Box sx={{ p: { xs: 1, sm: 2 } }}>
      <BasicModal
        show={showModalNew}
        close={() => setShowModalNew(!showModalNew)}
        sx={{
          "& .MuiBox-root": {
            borderRadius: 2,
          },
        }}
      >
        <Box sx={{ p: 3 }}>
          <Cadastrar
            refetchDadosBancarios={refetchDadosBancarios}
            setError={setError}
            setShowModal={setShowModalNew}
            setSuccessMessage={setSuccessMessage}
          />
        </Box>
      </BasicModal>

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
          flexWrap: "wrap",
          gap: 2,
        }}
      >
        <Typography variant="h5" sx={{ fontWeight: 600 }}>
          Dados Bancários
        </Typography>
        <ButtonCustom
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => setShowModalNew(true)}
          sx={{
            borderRadius: 2,
            px: 3,
          }}
        >
          Adicionar dado bancário
        </ButtonCustom>
      </Box>

      {(isLoading || loadingAction || isLoadingQuery) && (
        <Box>
          {[1, 2].map((item) => (
            <Card key={item} sx={{ p: 2, mb: 2, borderRadius: 2 }}>
              <Skeleton
                animation="wave"
                height={40}
                width="60%"
                sx={{ mb: 2 }}
              />
              <Skeleton
                animation="wave"
                height={20}
                width="40%"
                sx={{ mb: 1 }}
              />
              <Skeleton animation="wave" height={20} width="30%" />
            </Card>
          ))}
        </Box>
      )}

      {!isLoading && !loadingAction && dadosBancarios?.length > 0 ? (
        <Box>
          {dadosBancarios.map(
            (d, index) =>
              d.id > 0 && (
                <Fragment key={index}>
                  {isOperacao ? (
                    <DadosBancariosOperacao dados={d} />
                  ) : (
                    <DadosBancariosGestao dados={d} />
                  )}
                </Fragment>
              )
          )}
        </Box>
      ) : !isLoading && !loadingAction ? (
        <Paper
          sx={{
            p: 4,
            textAlign: "center",
            // bgcolor: alpha(theme.palette.primary.main, 0.05),
            borderRadius: 2,
          }}
        >
          <AccountBalanceWalletIcon
            color="primary"
            sx={{ fontSize: 48, mb: 2 }}
          />
          <Typography variant="h6" gutterBottom>
            Nenhum banco cadastrado
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Você ainda não cadastrou nenhum dado bancário.
          </Typography>
          <ButtonCustom
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => setShowModalNew(true)}
          >
            Adicionar Primeiro Banco
          </ButtonCustom>
        </Paper>
      ) : null}
    </Box>
  );
}
